// Sticky Header
class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.sectionID = `#${this.parentElement.id}`;
      this.parentElement.classList.add('shopify-section-header');
      this.parentElement.classList.add('shopify-section-header-sticky');
      this.parentElement.classList.add('shopify-section-header-hidden');
    }
  
    /**
     * Calls when Component is Initialized in DOM
     *
     */
    connectedCallback() {
      this.header = document.querySelector(this.sectionID);
      this.headerBounds = {};
      this.currentScrollTop = 0;
  
      this.onScrollHandler = this.onScroll.bind(this);
  
      window.addEventListener('scroll', this.onScrollHandler, false);
  
      this.createObserver();
    }
  
    /**
     * Calls when Component is removed from DOM
     *
     */
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  
    /**
     * To observe Sticky header visibility on User Scroll
     *
     */
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
  
      observer.observe(this.header);
    }
  
    /**
     * Window Scroll event
     *
     */
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
  
      this.currentScrollTop = scrollTop;
    }
  
    /**
     * Hide Sticky header
     * Close Menu Drawer / Seach Modal / Cart Drawer
     *
     */
    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeSearchModal();
      this.closeMenuDropdowns();
      const topbar = document.querySelectorAll('[data-top-bar]')[0].offsetHeight;
      document.querySelector(this.sectionID).style.transform = 'translateY(-'+ topbar+'px)';
    }
  
    /**
     * Show Sticky Header
     *
     */
    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      
      const topbar = document.querySelectorAll('[data-top-bar]')[0].offsetHeight;
      document.querySelector(this.sectionID).style.transform = 'translateY(-'+ topbar+'px)';
    }
  
    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.querySelector(this.sectionID).style.transform = 'translateY(0)';
    }
  
    /**
     * Close Search Modal on Window Scroll
     *
     */
    closeSearchModal() {
      this.searchModal = this.searchModal || document.querySelector('search-modal');
      if(!this.searchModal) return;
      if(this.searchModal){
        this.searchModal.close(false);

      }
    }
  
    /**
     * Close Menu Dropdowns
     *
     */
 closeMenuDropdowns() {

  const openDropdowns = Array.from(document.querySelectorAll('.dropdown.open'));

  if (!openDropdowns.length) {
    return;
  }

  openDropdowns.forEach((ele) => {
    if (ele && ele.classList.contains('open')) {
      ele.classList.remove('open');
    }
  });
}

  }
  customElements.define('sticky-header', StickyHeader);